import React from "react";
import Weather from "./Weather.js";

function App() {
  return (
    <div className="App">
      <Weather />
    </div>
  );
}

export default App;

// import React, { useState } from 'react';
// import axios from 'axios';

// const API_KEY = 'd28860fefdff84d27d99d36b36c430b5';

// const WeatherApp = () => {
//   const [city, setCity] = useState('');
//   const [weatherData, setWeatherData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const fetchWeatherData = async () => {
//     setLoading(true);
//     setError('');
//     try {
//       const response = await axios.get(
//         `https://api.openweathermap.org/data/3.0/weather?q=${city}&appid=${API_KEY}&units=metric`
//         // `https://api.openweathermap.org/data/3.0/onecall?lat={lat}&lon={lon}&exclude={part}weather?q=${city}&appid=${API_KEY}`
//       );
//       setWeatherData(response.data);
//     } catch (error) {
//       setError('City not found. Please try again.');
//     }
//     setLoading(false);
//   };

//   const handleSearch = (e) => {
//     e.preventDefault();
//     fetchWeatherData();
//   };

//   return (
//     <div>
//       <h1>Weather App</h1>
//       <form onSubmit={handleSearch}>
//         <input
//           type="text"
//           value={city}
//           onChange={(e) => setCity(e.target.value)}
//           placeholder="Enter city name"
//         />
//         <button type="submit">Search</button>
//       </form>
//       {loading && <p>Loading...</p>}
//       {error && <p>{error}</p>}
//       {weatherData && (
//         <div>
//           <h2>{weatherData.name}</h2>
//           <table>
//             <tbody>
//               <tr>
//                 <td>Temperature</td>
//                 <td>{weatherData.main.temp}°C</td>
//               </tr>
//               <tr>
//                 <td>Description</td>
//                 <td>{weatherData.weather[0].description}</td>
//               </tr>
//               <tr>
//                 <td>Humidity</td>
//                 <td>{weatherData.main.humidity}%</td>
//               </tr>
//               <tr>
//                 <td>Wind Speed</td>
//                 <td>{weatherData.wind.speed} m/s</td>
//               </tr>
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// // };

// export default WeatherApp;
